import { render, staticRenderFns } from "./RoleSetting.vue?vue&type=template&id=a4a35f82"
import script from "./RoleSetting.vue?vue&type=script&lang=js"
export * from "./RoleSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports